import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';

export const NewADUserDetails = ({ ticket }) => (
  <SectionCard title="Account information">
    <TextDataField
      name="First Name"
      value={ticket && ticket.ticket_data.first_name} />
    <TextDataField
      name="Last Name"
      value={ticket && ticket.ticket_data.last_name} />
    <TextDataField
      name="Email"
      value={ticket && ticket.ticket_data.email} />
  </SectionCard>
);

NewADUserDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
NewADUserDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
